import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { disableBodyScrolling } from '@/utils/disableBodyScrolling';
import { cart } from '@/theme/Cart';

@Component
export class MobileMenu extends ThemeComponent {

    @Ref() inner!: HTMLElement;
    @Ref() closeButton!: HTMLButtonElement[];
    @Ref() parentLink!: HTMLElement[];
    @Ref({ required: false }) returnButton!: HTMLElement[];
    @Ref() cartQuantity!: HTMLElement;

    init() {

        // Handle mobile menu close
        this.initCloseButtonClickEventListener();

        // Handle outer element click
        this.handleOuterElementClick();

        // Handle parent link clicks
        this.initParentLinkClickEventListener();

        // Handle return button clicks
        this.initReturnButtonClickEventListener();

        // Handle cart quantity update
        this.$subscribe(cart.onChange, () => this.cartQuantityUpdate());
    }

    initCloseButtonClickEventListener() {
        for (const elem of this.closeButton) {
            this.$listen(elem, 'click', () => {

                // Remove class
                this.classList.remove('mobile-menu--active');
                const childSections = this.querySelectorAll('.mobile-menu-child-section');
                for (const childSection of childSections) {
                    childSection.classList.remove('mobile-menu-child-section--active');
                }

                // Enable body scrolling
                disableBodyScrolling(false, 0);
            });
        }
    }

    handleOuterElementClick() {
        this.$listen(this, 'click', (e) => {
            if (e.target && this.classList.contains('mobile-menu--active')) {
                const clickedElement = e.target as HTMLElement;
                if (clickedElement === this) {
                    this.classList.remove('mobile-menu--active');
                    disableBodyScrolling(false, 0);
                }
            }
        });
    }

    initParentLinkClickEventListener() {
        for (const elem of this.parentLink) {
            this.$listen(elem, 'click', (e) => {
                e.preventDefault();

                // Check if child section eists
                const childSection = elem.parentNode?.querySelector('.mobile-menu-child-section');
                if (childSection) {

                    // Add active class
                    childSection.classList.add('mobile-menu-child-section--active');

                    // Scroll to top
                    this.inner.scrollTop = 0;
                } else {

                    // Rediirect to element href
                    const href = elem.getAttribute('href');
                    if (href) {
                        window.location.href = href;
                    }
                }
            });
        }
    }

    initReturnButtonClickEventListener() {
        for (const elem of this.returnButton) {
            this.$listen(elem, 'click', () => {

                // Check if child section eists
                const childSection = elem.closest('.mobile-menu-child-section');
                if (childSection) {

                    // Remove active class
                    childSection.classList.remove('mobile-menu-child-section--active');
                }
            });
        }
    }

    cartQuantityUpdate() {
        const count = cart.getCartItemCount();
        this.cartQuantity.textContent = `${count}`;
    }
}
